import Base from './base'
import renderFields from './beacon.pug'

export default class Beacon extends Base
  @label: "Beacon"

  renderFields: renderFields
